import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeEsMX from '@angular/common/locales/es-MX';
import { LOCALE_ID, NgModule, inject, provideAppInitializer } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ContextMenu } from 'primeng/contextmenu';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { ErrorHandlerInterceptor } from './core/interceptors/error-handler.interceptor';
import { JwtInterceptor } from './core/interceptors/http.token.interceptor';
import { LoaderInterceptor } from './core/interceptors/loader.interceptor';
import { TimeZoneInterceptor } from './core/interceptors/time-zone.interceptor';
import { LastActiveService } from './core/services/last-active.service';
import { LoginComponent } from './modules/authentication/pages/login/login.component';
import { ResetPasswordComponent } from './modules/authentication/pages/reset-password/reset-password.component';
import { ValidateUserComponent } from './modules/authentication/pages/validate-user/validate-user.component';
import { MapContextMenu } from './shared/components/map/map-context-menu/map-context-menu';
import { getSpanishPaginatorIntl } from './core/i18n/paginator-intl';

// Register the locale data for Mexican Spanish
registerLocaleData(localeEsMX, 'es-MX');

@NgModule({
  declarations: [AppComponent, LoginComponent, ValidateUserComponent, ResetPasswordComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule,
    FormsModule,
    CoreModule,
    AppRoutingModule,
    MatButtonModule,
    NgbModule,
    ReactiveFormsModule,
    ContextMenu,
    MapContextMenu,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-MX' },
    { provide: MatPaginatorIntl, useFactory: getSpanishPaginatorIntl },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TimeZoneInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorHandlerInterceptor, multi: true },
    provideAppInitializer(() => {
      const initializerFn = (
        (lastActiveService: LastActiveService) => () =>
          lastActiveService.setUp()
      )(inject(LastActiveService));
      return initializerFn();
    }),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
